/**
 * Enforces the use of the main production domain by redirecting
 * from Firebase hosting URLs to the main domain
 */
export const enforceMainDomain = () => {
  // Only run in production
  if (import.meta.env.MODE !== 'production') {
    return;
  }

  const currentHost = window.location.hostname;
  const mainDomain = 'app.notego.ai';

  // List of Firebase hosting domains to redirect from
  const firebaseHostingDomains = [
    'notegonan.web.app',
    'notegonan.firebaseapp.com',
    // Add any other Firebase hosting URLs here
  ];

  // Check if current host is a Firebase hosting domain
  if (firebaseHostingDomains.some((domain) => currentHost.includes(domain))) {
    // Preserve the full path and query parameters
    const newUrl = `https://${mainDomain}${window.location.pathname}${window.location.search}${window.location.hash}`;

    // Perform the redirect
    window.location.replace(newUrl);
  }
};
